itsoftApp.createModule("toggleTabs", function () {
    var module = this;

    var tabsInitialized = false;

    var initTabToggle = function (tabs) {
        var isContainingTabs = tabs.hasAttribute("data-tabs-caption");
        var togglers = tabs.querySelectorAll(".js-toggle:not(.js-toggle--ui)"); /* находим на странице возможный тогглер */
        var togglersUi = tabs.querySelectorAll(".js-toggle");
        var noHash = tabs.hasAttribute("data-no-hash"); // если стоит этот атрибут, табы будут перкеключаться без изменения хэша
        var tabsItems; // все кнопки
        var currentActiveTabs; // активные кнопки
        var currentActiveContents; // секции активной вкладки
        var clickedTab; // кнопка, на которую кликнули в данный момент
        var clickedTabName; // название кнопки, на которую кликнули
        var dataButtons;
        var dataSection;
        var goToTabButtons = document.querySelectorAll(".js-go-to-tab");

        Array.prototype.forEach.call(togglers, function (toggler) {
            toggler.addEventListener("click", function (evt) {
                evt.preventDefault();
                console.log("gototabclivk")
                goToTab();
            });
        });

        if (goToTabButtons.length > 0) {
            Array.prototype.forEach.call(goToTabButtons, function (button) {
                button.addEventListener("click", function (evt) {
                    evt.preventDefault();
                    var extraHash = button.getAttribute("data-tab-name");
                    console.log(extraHash, " extraHash")
                    goToHash(extraHash);
                });
            });
        }

        // Если табы включают в себя другие табы...
        if (isContainingTabs) {
            var dataLevel = tabs.querySelector("[data-level]");

            // Получаем уровень (название уровня) табов, если есть
            if (dataLevel) {
                var dataLevelValue = dataLevel.getAttribute("data-level");
            }
            // Название табов
            var dataTabsValue = tabs.getAttribute("data-tabs-caption");

            // Назвавние кнопок табов 
            dataButtons = tabs.querySelector("[data-tabs-buttons='" + dataTabsValue + "']");

            // Название секции табов
            dataSection = tabs.querySelector("[data-tabs-section='" + dataTabsValue + "']");

            // Находим все кнопки по названию
            tabsItems = dataButtons.querySelectorAll(".js-tab-name");

            // Находим активные табы
            currentActiveTabs = dataButtons.querySelectorAll(".js-tab-name--active");

            if (dataLevel && dataLevelValue === dataTabsValue) {
                /* если название указано, находим активные секции только внутри блока с названием табов */
                currentActiveContents = dataSection.querySelectorAll(".js-tab-content--active[data-level='" + dataTabsValue + "']");
            } else {
                /* иначе находим все */
                currentActiveContents = dataSection.querySelectorAll(".js-tab-content--active");
            }

            // console.log(currentActiveTabs, " ", currentActiveContents)

        /* ...иначе на странице только один уровень табов */
        } else {
            dataButtons = tabs.querySelector(".js-tabs-list");
            dataSection = tabs.querySelector(".js-tabs-content");
            tabsItems = dataButtons.querySelectorAll(".js-tab-name");
            currentActiveTabs = dataButtons.querySelectorAll(".js-tab-name--active");
            currentActiveContents = dataSection.querySelectorAll(".js-tab-content--active");
        }

        var dataActiveSectionClass;
        var dataActiveSectionSelector;
        var sectionElement;

        var goToHash = function (newHash, type) {
            var element;
            var contentElements;
            var contentSelector;

            if (newHash) {
                newHash = newHash.replace(/^#/,"");
                var selector = "[data-tab-name='" + newHash + "']";
                contentSelector = "[data-content-url='" + newHash + "']";
                element = dataButtons.querySelector(selector);
                contentElements = dataSection.querySelectorAll(contentSelector);
            } else {
                element = tabsItems[0];
                contentSelector = "[data-content-url='" + element.getAttribute("data-tab-name") + "']";
                contentElements = dataSection.querySelectorAll(contentSelector);
            }

            // DEBUG && console.log("contentElementsHash", contentElements);

            if (element) {
                goToTab(element, contentElements, type);
            }
        };

        var goToTab = function (tab, contents, type) {
            /* Логика переключения к определенному табу */
            var toggleFlag = 0;

            if (!tab) {
                var inactiveTab = tabs.querySelector(".js-tab-name:not(.js-tab-name--active)");
                console.log(inactiveTab)
                var tab = inactiveTab; 
            }

            if (!contents) {
                var contents = dataSection.querySelectorAll(".js-tab-content:not(.js-tab-content--active)");
            }

            if (tabs.classList.contains("js-init-settings")) {
                tabs.classList.remove("js-init-settings");
            }

            clickedTab = tab;

            if (!clickedTab.classList.contains("js-tab-name--active")) {
                if (togglers.length > 0 && !toggleFlag) {
                    Array.prototype.forEach.call(togglersUi, function (toggler) {
                        toggler.classList.toggle("js-toggle--active");
                    });
                    toggleFlag = 1;
                }
            }

            Array.prototype.forEach.call(currentActiveTabs, function (currentActiveTab) {
                currentActiveTab.classList.remove("js-tab-name--active");
            });

            Array.prototype.forEach.call(currentActiveContents, function (currentActiveContent) {
                currentActiveContent.classList.remove("js-tab-content--active");
            });

            if (dataActiveSectionClass) {
                sectionElement.classList.remove(dataActiveSectionClass);
            }

            if (clickedTab.hasAttribute("data-slider-name") && type !== "slider") {
                var slideIndex = clickedTab.getAttribute("data-slide-to");
                var sliderName = clickedTab.getAttribute("data-slider-name");
                if (itsoftApp.modules.slidersLibrary.sliders[sliderName]) {
                    itsoftApp.modules.slidersLibrary.sliders[sliderName].slideTo(+slideIndex);
                }
            }
            clickedTabName = clickedTab.getAttribute("data-tab-name");

            if (!noHash) {
                location.hash = clickedTabName;
            }
            currentActiveTabs = dataButtons.querySelectorAll("[data-tab-name='" + clickedTabName + "']");
            
            dataActiveSectionSelector = tab.getAttribute("data-section-selector");
            if (dataActiveSectionSelector) {
                sectionElement = dataSection.querySelector(dataActiveSectionSelector);
            }

            dataActiveSectionClass = tab.getAttribute("data-section-class");

            if (dataActiveSectionClass) {
                sectionElement.classList.add(dataActiveSectionClass);
            }

            currentActiveContents = contents;
    
            Array.prototype.forEach.call(currentActiveTabs, function (currentActiveTab) {
                currentActiveTab.classList.add("js-tab-name--active");
            });

            Array.prototype.forEach.call(currentActiveContents, function (currentActiveContent) {
                var customScroll = currentActiveContent.querySelector(".custom-scroll");
                if (customScroll && !customScroll.classList.contains("js-triggered")) {
                    customScroll.classList.add("js-triggered");
                    itsoftApp.modules.customScrollbar.callback(customScroll);
                }

                currentActiveContent.classList.add("js-tab-content--active");
            });

            Array.prototype.forEach.call(itsoftApp.modules.scrollEffects.scrollEffectElements, function (scrollEffectElement) {
                scrollEffectElement._check();
            });
        };

        var onTabClick = function (currentTab) {
            var tabSelector;
            if (currentTab.hasAttribute("data-tab-name")) {
                tabSelector = currentTab.getAttribute("data-tab-name");

                if (!noHash) {
                    location.hash = tabSelector;
                }
            }
            var tabsContents = dataSection.querySelectorAll("[data-content-url='" + tabSelector + "']");
            // DEBUG && console.log("dataSection", dataSection);
            // DEBUG && console.log("contentElements", tabsContents);
            // После обработки клика передаём элемент, на который произошёл клик, и элемент (вкладка), который должен быть показан универсальной функции goToTab
            if (!currentTab.closest(".js-disabled-tabs")) {
                goToTab(currentTab, tabsContents);
            }
        };

        var addTabClickListener = function (tab) {
            /* Добавляем обработчик события клика */
            tab.addEventListener("click", function (evt) {
                evt.preventDefault();
                if (!evt.currentTarget.classList.contains("js-tab-name--active")) {
                    onTabClick(tab);
                } else if (tabs.classList.contains("js-init-settings")) {
                    tabs.classList.remove("js-init-settings");
                }
            });
        };

        for (var i = 0; i < tabsItems.length; i++) {
            addTabClickListener(tabsItems[i]);
        }

        if (!tabsInitialized) {
            tabsInitialized = true;

            if (location.hash && !noHash) {
                goToHash(location.hash, "hash");
            }

            /* Этот метод позволяет перейти к любой вкладке по хэшу из другого модуля */
            module.callback.goToHash = goToHash;
        }

        tabsItems = dataButtons.querySelectorAll(".js-tab-name");
    };

    var initTabs = function (tabs) {
        /* Функция, к которой можно обращаться извне, чтобы инициализировать очередной блок с вкладками */
        if (tabs) {
            initTabToggle(tabs);
        }
    };

    module.callback = {};
    module.callback.init = initTabs;
});